import { SubPageLayout } from "@/components/SubPageLayout";
import { SITE_IMAGES } from "@/lib/site-data";

export default function DigitalisNyomtatas() {
  return (
    <SubPageLayout
      eyebrow="Digitális nyomtatás"
      title="Minőségi nyomtatás, egyedi méretekben."
      intro="Reklámmolinókra, építési hálókra, jármű- és sátorponyvákra, vinylekre."
      heroImage="/assets/gallery/nyomtato.webp"
      bullets={[
        { title: "Változatos méretek", text: "Kicsitől a nagy felületekig." },
        { title: "Ütős megjelenítés", text: "Élénk színek, képek, színátmenetes és 3D hatású grafikák nyomtatása." },
        { title: "Saját nyomdai géppark", text: "" },
      ]}
      gallery={SITE_IMAGES.printGallery}
    />
  );
}
